module.exports = __webpack_public_path__ + "static/media/google_excel.09813a3b.svg";